import { render } from "./HomeIntegrationsIcon.vue?vue&type=template&id=dc9faaa0"
import script from "./HomeIntegrationsIcon.vue?vue&type=script&lang=js"
export * from "./HomeIntegrationsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__